import { Auction, GetOntologyType } from "core/types";
import { Card } from "ds_legacy/components/InfoCard/index";
import { Divider, ResponsiveLayout } from "ds_legacy/materials/layouts";
import { margin } from "ds_legacy/materials/metrics";
import { Body, Subheading } from "ds_legacy/materials/typography";
import Translations from "translations/types";
import {
  BooleanField,
  CategoryContainer,
  OntologyField,
  StringField,
} from "../organisms/PatientProfileDetailsShared/shared";

function AccompanyingPersonPrint({
  auction,
  isForCareprovider,
  translations,
}: {
  auction: Auction;
  isForCareprovider?: boolean;
  translations: Translations;
}) {
  const data = auction?.patient?.transport;
  if (!data) return null;

  const { accompanying_person, require_accompanying_person } = data;
  if (!isForCareprovider && !accompanying_person)
    return (
      <BooleanField
        hasValue={require_accompanying_person}
        label={translations.patient.transport.accompanyingPersonNecessary}
      />
    );
  if (accompanying_person?.decrypted)
    return (
      <Body>{`${translations.patient.transport.accompanyingPersonNecessary}: ${accompanying_person?.decrypted}`}</Body>
    );
  return null;
}

export function StaticTransportInfoCard({
  auction,
  getOntology,
  isForCareprovider = false,
  translations,
}: {
  auction: Auction;
  isForCareprovider?: boolean;
  getOntology: GetOntologyType;
  translations: Translations;
}) {
  const data = auction.patient.transport;

  if (!data) return null;

  const {
    daily_transport_needed,
    require_accompanying_person,
    transport_organiser,
    transport_type,
  } = data;

  if (
    !transport_type &&
    !transport_organiser &&
    !daily_transport_needed &&
    !require_accompanying_person
  ) {
    return null;
  }

  if (isForCareprovider) {
    return (
      <>
        <Divider />
        <Subheading bold>
          {translations.patient.transport.typeOfTransport}
        </Subheading>
        <ResponsiveLayout>
          <CategoryContainer testId="transport_type">
            <OntologyField
              getOntology={getOntology}
              isVerticalLayout
              type="transportType"
              value={transport_type}
            />
          </CategoryContainer>
          <CategoryContainer testId="daily_transport_needed">
            <BooleanField
              hasValue={daily_transport_needed}
              label={translations.patient.transport.dailyTransportNeeded}
            />
          </CategoryContainer>
        </ResponsiveLayout>
        <ResponsiveLayout>
          <CategoryContainer testId="accompanying_person">
            <AccompanyingPersonPrint
              auction={auction}
              isForCareprovider={isForCareprovider}
              translations={translations}
            />
          </CategoryContainer>
          <CategoryContainer testId="transport_organiser">
            {transport_organiser && (
              <StringField
                prefix={translations.patient.transport.organizedBy.title}
                testId="transport_organiser"
                value={transport_organiser}
              />
            )}
          </CategoryContainer>
        </ResponsiveLayout>
      </>
    );
  }

  return (
    <Card noBorder width="100%">
      <Subheading bold>{translations.patient.transport.stepTitle}</Subheading>

      <OntologyField
        getOntology={getOntology}
        isVerticalLayout
        type="transportType"
        value={transport_type}
      />
      <BooleanField
        hasValue={daily_transport_needed}
        label={translations.patient.transport.dailyTransportNeeded}
      />
      <AccompanyingPersonPrint
        auction={auction}
        isForCareprovider={isForCareprovider}
        translations={translations}
      />
      {transport_organiser && (
        <StringField
          prefix={translations.patient.transport.organizedBy.title}
          testId="transport_organiser"
          value={transport_organiser}
        />
      )}
      <Divider margin={margin(2, 0, 0, 2)} />
    </Card>
  );
}
